import { useEffect } from 'react';

// messaging 
import { messaging } from '@/config/firebase';
import { onMessage } from "firebase/messaging";

// hooks 
import { playNotificationSound } from '@/hooks/useUnlockNotificationSound';
import { useNotificationStore } from "@/state/useNotificationStore";
import { useOrdersStore } from "@/state/useOrdersStore";

// functions 
import { normalizeNotification } from "@/features/notification/function/normalizeNotification";
import { generateOrderData } from "@/features/notification/function/generateOrderData";

// utils 
import { showToast } from '@/utils/toast';




export function useNotificationListener() {

    useEffect(() => {
        if (!messaging) return;

        const unsubscribe = onMessage(messaging, (payload: any) => {

            // normalize and store notification
            const notification = normalizeNotification(payload);
            if (!notification) return;

            useNotificationStore.getState().addNotification(notification);

            const type = payload.data?.type as string | undefined;
            const rawOrder = payload.data?.order;

            // ── handle typed messages ─────────────────────────────────────
            switch (type) {

                case 'new_order': {
                    const order = generateOrderData(rawOrder);
                    if (order) {
                        useOrdersStore.getState().upsertOrder(order);
                    }
                    playNotificationSound('new_order');
                    break;
                }

                case 'update_order': {
                    const order = generateOrderData(rawOrder);
                    if (order) {
                        useOrdersStore.getState().upsertOrder(order);
                    }

                    // play sound based on order status
                    if (order?.status === 'cancelled') {
                        playNotificationSound('order_cancelled');
                    } else if (order?.status === 'delivered') {
                        playNotificationSound('order_delivered');
                    } else {
                        playNotificationSound('update_order');
                    }
                    break;
                }

                default:
                    // general notification sound
                    playNotificationSound(type);
                    break;
            }

            // ── show toast ────────────────────────────────────────────────
            const toastMessage = `${notification.title} - ${notification.body}`
                .trim()
                .slice(0, 100);

            const deepLink = notification?.data?.deeplink;

            if (toastMessage) {
                showToast(
                    toastMessage,
                    'info',
                    {
                        autoClose: 2000,
                        onClick: () => {
                            useNotificationStore.getState().markAsRead(notification.id);
                            if (deepLink) {
                                window.open(deepLink, '_blank');
                            }
                        },
                    }
                );
            }
        });

        return unsubscribe;
    }, []);
}